import React from 'react';
import { cn } from '@/lib/utils';

interface BlogSidebarSectionProps {
	className?: string;
	children: React.ReactNode;
}

export const BlogSidebarSection = ({
	className,
	children,
}: BlogSidebarSectionProps) => {
	return <div className={cn('space-y-4', className)}>{children}</div>;
};
